import { NotificationConstants as Constants } from '../types'

const initialState = {
    notifications: [],    
};

export function notificationReducer(state = initialState, action) {
    switch (action.type) {  
        
        case Constants.GET:            
            return {
                ...state,
                notifications: action?.payload?.notifications,                
            };
      
        case Constants.ADD:
            return {
                ...state,
                notifications: [action?.payload, ...state?.notifications]
            }

        case Constants.UPDATE:         
            return{
                ...state,
                notifications: state?.notifications?.filter(x => parseInt(x?.id) !== parseInt(action?.payload?.notification?.id))                
            }
            
            // const index = state.notifications.findIndex(x => parseInt(x.id) ===  parseInt(action?.payload?.notification?.id))
            // const newArray = [...state.notifications];
            // if(index > -1)
            //     newArray[index] = action?.payload?.notification
            // return {
            //     ...state,
            //     notifications: newArray                
            // }   

        case Constants.DELETE:
            return{
                ...state,
                notifications: state?.notifications?.filter(x => parseInt(x?.id) !== parseInt(action?.payload?.id))                
            };
       
        
        case Constants.FAIL:
            return{
                ...state,
                error: action?.error
            }
        
        case Constants.LOADING:
            return{
                ...state,
                error: null
            }

        case Constants.CLEAR:
            return{
                ...state,                
                notifications: []
            }
        default:
            return state
    }
}